import type { StoryType } from "@config";

export const createStoryFileKey = ({
  story,
  versionId = null,
  preview = true,
}: {
  story: StoryType;
  versionId: string | null | undefined;
  preview: boolean;
}) => {
  const { orgId, _id, settings } = story;
  const versionFragment = versionId ? `/${versionId}` : "";
  return preview
    ? `preview/${orgId}/${_id}${versionFragment}/${new Date().getTime()}`
    : getStoryPath({ orgId, canonical: settings.canonical, versionId });
};

export const getStoryPath = ({
  orgId,
  canonical,
  versionId,
}: {
  orgId: string;
  canonical: string;
  versionId: string | undefined | null;
}) => {
  const base = `${orgId}/${canonical}`;
  return versionId ? `${base}/${versionId}` : base;
};
